"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Indonesian (Indonesia)
function default_1(number, index) {
    return [
        ['baru saja', 'sebentar'],
        ['%s detik yang lalu', 'dalam %s detik'],
        ['1 menit yang lalu', 'dalam 1 menit'],
        ['%s menit yang lalu', 'dalam %s menit'],
        ['1 jam yang lalu', 'dalam 1 jam'],
        ['%s jam yang lalu', 'dalam %s jam'],
        ['1 hari yang lalu', 'dalam 1 hari'],
        ['%s hari yang lalu', 'dalam %s hari'],
        ['1 minggu yang lalu', 'dalam 1 minggu'],
        ['%s minggu yang lalu', 'dalam %s minggu'],
        ['1 bulan yang lalu', 'dalam 1 bulan'],
        ['%s bulan yang lalu', 'dalam %s bulan'],
        ['1 tahun yang lalu', 'dalam 1 tahun'],
        ['%s tahun yang lalu', 'dalam %s tahun'],
    ][index];
}
exports.default = default_1;
//# sourceMappingURL=id_ID.js.map